import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { UsuariosService, StorageService, ServicioService } from '../../../servicios/index.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl,Validators } from '@angular/forms';
declare var $;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  usuarios:any;
  user:any;
  @Output() ubicSidebar = new EventEmitter;
  usersBuscar:any[] = [];
  msj:boolean = false;
  termino:string;
  parametros:boolean;
  @Input() btnSidebar:any;
  sidebar:boolean = false;
  result:boolean;
  @Output() mostrarMarcas = new EventEmitter;
  marcas:boolean = false;
  selec_form:any;
  form_regisro:FormGroup;
  users_selec:any;
  datatime_form:any;
  selec_filtro:any;
  hora:any = {};
  minutos:any;
  data_registro:any = {};
  registro_subs:any;
  @Output() historial = new EventEmitter;

  constructor( public _us:UsuariosService, private route: ActivatedRoute, private storage:StorageService,
              private _servicio:ServicioService ) {
    this.usuarios = this._us.usuarios;
    this._us.usuarios.subscribe(data=>{
      this.user = data;

    });
    this.route.params.subscribe(params=>{
      if( params.id ){

      }
    });

    this.cargar_marcas();
    let user = storage.consult_storage("user");
    //this._us.ubicacion_users(user, "pizanho18").subscribe(data=>{
      //console.log(data);
    //});

  }

  ngOnInit() {
    //Date picker
    setTimeout(()=>{
      $("#btn-users-navbar").css({'height': '700px','overflow': 'scroll'});
    },1000);

    $('#reservation').daterangepicker();
    this._servicio.consult_users().subscribe(usuarios=>{
      this.users_selec = usuarios;
    });
    this.form();
    this.hora_min();
  }

  seguir_user( user:any ){
    this.ubicSidebar.emit({ 'user':user });
    //console.log("Seguir user:",user);
  }

  buscador( termino:string ){
    this.usersBuscar = this.buscarUser( termino );
    let buscar = this.usersBuscar.length;
    console.log("Buscar", this.usersBuscar.length);
    if(buscar >= 1){
      this.msj = false;
    }else{
      this.msj = true;
      this.termino = termino;
    }

  }

  buscarUser( termino:string ){
    let users = [];
    termino=termino.toLowerCase();
    this.termino = termino;
    if( termino ){
      for( let user of this.user){
        let nombre = user.$key.toLowerCase();
        if( nombre.indexOf( termino ) >= 0 ){
          this.result = true;
          users.push({$key:nombre, timestamp:user.timestamp, lat:user.lat, lng:user.lng});
        }else{
          this.msj = true;
        }
      }
      return users;
    }else{
      this.msj= false;
      console.log("campo vacío");
    }

  }

  sidebar_menu(){
    if( this.sidebar == true ){
      this.sidebar = false;
    }else{
      this.sidebar = true;
    }
  }

  mostrar_marcas( status:boolean ){

    if( status ){
      this.marcas = false;
      this.mostrarMarcas.emit({ "status_marcas":false })
    }else{
      this.marcas = true;
      this.mostrarMarcas.emit({ "status_marcas":true })
    }
  }
  cargar_marcas(){
    let marca = this.storage.consult_storage("marcas");

    if( marca == "true" ){
      this.marcas = true;
    }else{
      this.marcas = false;
    }
  }

  form(){
    this.form_regisro = new FormGroup({
      'select':new FormControl('', Validators.required),
      'filtro': new FormControl(''),
      'datatime': new FormControl(''),
      'hora_ini':new FormControl('',Validators.required),
      'min_ini':new FormControl('',Validators.required),
      'hora_fin':new FormControl('',Validators.required),
      'min_fin':new FormControl('',Validators.required)
    });

  }
  consult(){
    let valor_form = this.form_regisro.value;
    let input = $('#reservation').val();
    input=input.split("-");
    //alert(new Date(input[0]).getTime());
    let date_inicial =  new Date(input[0]+" "+ valor_form.hora_ini + ":" + valor_form.min_ini+":00").getTime().toString();
    let date_final   =  new Date(input[1]+" "+ valor_form.hora_fin + ":" + valor_form.min_fin+":00").getTime().toString();

    this.historial.emit({ user: valor_form.select, fecha_inicial: date_inicial, fecha_final: date_final});
    /*
    this.registro_subs = this._us.consult_registro(valor_form.select).subscribe(data=>{
      this.data_registro = data;

      for( let time of this.data_registro ){

        if( date_inicial < time.timestamp && date_final > time.timestamp ){

        }

      }
    });
    */
    console.log(date_inicial, date_final);
    console.log(this.form_regisro.value);



  }

  hora_min(){

    this.hora = [ "00","01","02","03","04","05","06","07","08","09","10","11",
                  "12","13","14","15","16","17","18","19","20","21","22","23" ];

    this.minutos = [ "00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19",
                     "20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39",
                     "40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59" ];
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/shared/sidebar/sidebar.component.ts